import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../config/Config";
import axios from "axios";

const initialState = {
    loading: false,
    error: null,
    response: null,
    template: null,
    data: null,
    analyticsList: null,
    campaign: null,
    whatsappChat: null
};

export const getWhatsappTemplate = createAsyncThunk("getWhatsappTemplate", async () => {
    try {
        const response = await instance.get("/crm/whatsapp/get-all-template");
        return response?.data;
    } catch (error) {
        return error;
    }
});

export const getAllWatsappList = createAsyncThunk("getAllWatsappList", async (listBody) => {
    try {
        const response = await instance.get(`/crm/whatsapp/get-all-messages?page=${listBody?.page}&search=${listBody?.search}&startDate=${listBody.startDate}&endDate=${listBody.endDate}&status=${listBody.status}`);
        return response?.data;
    } catch (error) {
        return error;
    }
});

export const getWhatsappAnalytics = createAsyncThunk("getWhatsappAnalytics", async (analyticsBody) => {
    try {
        const response = await instance.get(`/crm/whatsapp/whtsapp-analytics?&startDate=${analyticsBody.startDate}&endDate=${analyticsBody.endDate}`);
        return response?.data;
    } catch (error) {
        return error;
    }
});

export const getCampaignanalytics = createAsyncThunk("getCampaignanalytics", async (body) => {
    try {
        let params = '';
        if (body.template_name) {
            params = `?template_name=${body.template_name}&startDate=${body.startDate}&endDate=${body.endDate}`;
        } else {
            params = `?startDate=${body.startDate}&endDate=${body.endDate}`;
        }
        const response = await instance.get("/crm/whatsapp/campaign-analytics" + params);
        return response?.data;
    } catch (error) {
        return error;
    }
});
// {Whatsapp chat history}
export const getWhatsappChat = createAsyncThunk("getWhatsappChat", async (body) => {
    try {
        const response = await instance.get(`/crm/whatsapp/chat-thread?phone=${body?.phone}`);
        return response?.data;
    } catch (error) {
        return error;
    }
});


// {whatsapp message send}

export const sendWhatsappMessage = createAsyncThunk("sendWhatsappMessage", async (body) => {
    try {
        // debugger;

        const response = await instance.post(`/crm/whatsapp/send-whtsapp-message?recipientNumber=${body?.recipientNumber}&integretedNumber=${body?.integretedNumber}&text=${body?.text}&contentType=${body?.contentType}`);
        return response?.data;
    } catch (error) {
        return error;
    }
});




//SEND MULTIPLE TEMPLATE--------

export const sendMultipleTemplate = createAsyncThunk(
    "sendMultipleTemplate",
    async (body) => {
        // let data = body.map((ele) => ele.l_contact);
        // let modyfyData = [...data];
        let newObj = { bulk_ids: body };

        try {
            const response = await instance.post(
                `/crm/whatsapp/send-template`,
                newObj
            );
            return response?.data;
        } catch (error) {
            return error;
        }
    }
);

export const WhatsappSlice = createSlice({
    name: "WhatsappSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        //SEND TEMPLATE BULK NUMBERS----
        builder.addCase(sendMultipleTemplate.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(sendMultipleTemplate.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(sendMultipleTemplate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        });
        //SEND TEMPLATE BULK NUMBERS----
        builder.addCase(getWhatsappTemplate.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getWhatsappTemplate.fulfilled, (state, action) => {
            state.loading = false;
            state.template = action.payload;
        });
        builder.addCase(getWhatsappTemplate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        });

        builder.addCase(getAllWatsappList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAllWatsappList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(getAllWatsappList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        });

        builder.addCase(getWhatsappAnalytics.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getWhatsappAnalytics.fulfilled, (state, action) => {
            state.loading = false;
            state.analyticsList = action.payload;
        });
        builder.addCase(getWhatsappAnalytics.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        });

        builder.addCase(getCampaignanalytics.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getCampaignanalytics.fulfilled, (state, action) => {
            state.loading = false;
            state.campaign = action.payload;
        });
        builder.addCase(getCampaignanalytics.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        });

        builder.addCase(getWhatsappChat.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getWhatsappChat.fulfilled, (state, action) => {
            state.loading = false;
            state.whatsappChat = action.payload;
        });
        builder.addCase(getWhatsappChat.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        });

        builder.addCase(sendWhatsappMessage.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(sendWhatsappMessage.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(sendWhatsappMessage.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default WhatsappSlice.reducer;
